/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { SmartLink as Link, type SmartLinkProps } from '@/utils/smartLink';
import { forwardRef, type ReactNode } from 'react';

type StarcLinkProps = Omit<SmartLinkProps, 'to'> & {
  href?: string;
  to?: string;
};

/**
 * https://starc.autozone.com/web/recipes/LinkOverride/
 */
export const StarcLinkOverride = forwardRef<HTMLAnchorElement, StarcLinkProps>(
  function StarcLinkOverrideComp({ href, to, ...restProps }, ref): ReactNode {
    const targetHref = href || to;

    return targetHref === undefined ? (
      <a {...restProps} ref={ref}>
        {restProps.children}
      </a>
    ) : (
      <Link to={targetHref} {...restProps} ref={ref} />
    );
  },
);
